import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { spacing4 } from 'approot/shared/styles/spacing.style';
import { grey1, grey5 } from 'approot/shared/styles/colours.style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';
import {
  SettingsComponentMenuHr,
  SettingsComponentMenuInner,
} from 'approot/activity-builder/settings/settings-component-menu.style';
import { RangeSlider } from 'lib/form/range/range.style';
import { flexCentreAlignCss } from 'approot/shared/styles/flex.style';
import { ACTIVITY_BUILDER_IMAGE_CROP_ZOOM_Z_INDEX } from 'approot/activity-builder/activity-builder.constants';

export const ImageCrop = styled.div`
  position: relative;
`;

export const ImageCropSettings = styled.div`
  position: absolute;
  top: -${rem(42)} !important; // override popper styles
  height: ${rem(42)};
  transform: none !important; // override popper styles
  z-index: 10;
`;

export const ImageCropSettingsInner = styled(SettingsComponentMenuInner)`
  display: block;
`;

export const ImageCropSettingsFields = styled.div`
  display: flex;
  gap: ${rem(spacing4)};
  padding-right: ${rem(spacing4)};
  white-space: nowrap;

  ${SettingsComponentMenuHr} {
    height: ${rem(32)};
    margin: 0;
  }
`;

export const ImageCropZoom = styled.div`
  background-color: ${grey1};
  border-radius: ${rem(borderRadius8)};
  border: 1px solid ${grey5};
  padding: ${rem(spacing4)};
  position: absolute;
  bottom: -${rem(52)};
  left: 50%;
  transform: translateX(-50%);
  width: ${rem(240)};
  z-index: ${ACTIVITY_BUILDER_IMAGE_CROP_ZOOM_Z_INDEX};

  ${RangeSlider} {
    margin-bottom: 0;
  }
`;

export const ImageCropWrapper = styled.div`
  border-radius: ${rem(borderRadius8)};
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
`;

export const ImageCropWrapperFit = styled(ImageCropWrapper)`
  ${flexCentreAlignCss}
`;

export const ImageCropperContainer = styled.div`
  border-radius: ${rem(borderRadius8)};
  position: absolute;
  overflow: hidden;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
`;
